import { Fragment, type ReactNode } from "react";

// =============================================================================
// Rendu d'un texte légal versionné (legal_texts) : paragraphes séparés par une
// ligne vide ; les lignes commençant par « - » deviennent des puces. Utilisé
// dans la fenêtre de consentement, la page Confidentialité et les paramètres.
// =============================================================================

export function LegalTextBody({ text, className }: { text: string; className?: string }) {
  const blocks: ReactNode[] = [];
  const paragraphs = text
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);

  paragraphs.forEach((para, i) => {
    const lines = para
      .split("\n")
      .map((l) => l.trim())
      .filter(Boolean);
    const allBullets = lines.length > 0 && lines.every((l) => l.startsWith("- "));
    if (allBullets) {
      blocks.push(
        <ul key={i} className="list-disc space-y-1 pl-5">
          {lines.map((l, j) => (
            <li key={j}>{l.slice(2)}</li>
          ))}
        </ul>,
      );
    } else {
      // Lignes simples conservées : un saut de ligne dans un paragraphe reste
      // un saut de ligne (pas de fusion silencieuse).
      blocks.push(
        <p key={i}>
          {lines.map((l, j) => (
            <Fragment key={j}>
              {j > 0 && <br />}
              {l.startsWith("- ") ? `• ${l.slice(2)}` : l}
            </Fragment>
          ))}
        </p>,
      );
    }
  });

  return <div className={className ?? "space-y-3 text-sm leading-relaxed"}>{blocks}</div>;
}
